import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, flatMap, switchMap } from 'rxjs/operators';
import * as fromShared from '../../shared';
import {
    DisplayMessageMinimum,
    IStatusMessage,
    ResponseStatus
} from '../../shared';
import { TaskTimerService } from '../task-timer.service';
import * as TimerActions from './task-timer.actions';
import * as TimerHistoryActions from './timer-history/task-timer-history.actions';
import moment from 'moment';

@Injectable()
export class TaskTimerEffects {
    constructor(
        private actions$: Actions,
        private service: TaskTimerService,
    ) {}

    get$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(TimerActions.getTaskTimer),
            switchMap(a =>
                this.service.get().pipe(
                    flatMap(resp => [
                        TimerActions.loadTaskTimers({
                            taskTimers: JSON.parse(resp)
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    put$ = createEffect(() =>
        this.actions$.pipe(
            ofType(TimerActions.putTaskTimer),
            switchMap(a =>
                this.service.put(a.JsonString).pipe(
                    flatMap(c => [
                        // TimerActions.updateTaskTimers({
                        //     taskTimers: [
                        //         {
                        //             id: `${JSON.parse(c)[0].empauthid}-${JSON.parse(c)[0].timerid}`,
                        //             changes: JSON.parse(c)[0]
                        //         }
                        //     ]
                        // }),
                        TimerActions.upsertTaskTimers({
                            taskTimers: JSON.parse(c)
                        })

                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );

    putHist$ = createEffect(() =>
        this.actions$.pipe(
            ofType(TimerActions.putTaskTimerHistory),
            switchMap(a =>
                this.service.put(a.JsonString).pipe(
                    flatMap(c => [
                        // TimerActions.updateTaskTimers({
                        //     taskTimers: [
                        //         {
                        //             id: `${JSON.parse(c)[0].empauthid}-${JSON.parse(c)[0].timerid}`,
                        //             changes: JSON.parse(c)[0]
                        //         }
                        //     ]
                        // }),
                        TimerHistoryActions.upsertTaskTimerHistorys({
                            TaskTimerHistorys: JSON.parse(c)
                        }),
                        TimerHistoryActions.postTaskTimerHistory({ StartDate: a.StartDate, EndDate: a.EndDate })

                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
}
